import { useState, type FormEvent } from "react";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import type { Brand } from "../../../../shared/types";

interface BrandProfileProps {
  brand: Brand;
  onSave: (data: Partial<Brand>) => void;
  saving?: boolean;
}

export function BrandProfile({ brand, onSave, saving }: BrandProfileProps) {
  const [name, setName] = useState(brand.name);
  const [industry, setIndustry] = useState(brand.industry);
  const [targetAudience, setTargetAudience] = useState(brand.target_audience);
  const [websiteUrl, setWebsiteUrl] = useState(brand.website_url || "");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    onSave({
      name,
      industry,
      target_audience: targetAudience,
      website_url: websiteUrl || null,
    });
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <Input label="Brand name" value={name} onChange={(e) => setName(e.target.value)} required />
      <Input label="Industry" value={industry} onChange={(e) => setIndustry(e.target.value)} required />
      <Input
        label="Target audience"
        value={targetAudience}
        onChange={(e) => setTargetAudience(e.target.value)}
        placeholder="e.g. Solo founders building with AI"
        required
      />
      <Input
        label="Website URL"
        type="url"
        value={websiteUrl}
        onChange={(e) => setWebsiteUrl(e.target.value)}
        placeholder="https://yoursite.com"
      />

      <Button type="submit" disabled={saving}>
        {saving ? "Saving..." : "Save profile"}
      </Button>
    </form>
  );
}
